import { Constructor } from '../../../../global/constructor';
import TrackedModel from '~/models/tracked/trackedModel';
import NotificationsContainable, { INotificationsContainer } from '~/mixins/notificationsContainable';
import Notification from '~/models/notifications/notification';
import OnFlowErrorNotificationFactory from '~/models/processFlows/onFlowErrorNotificationFactory';
import { IDynamicReferencedThing } from '~/interfaces/dynamicFieldsInterfaces';
import Guid from '~/helpers/guid';
import { DynamicReferenceType } from '~/enums/dynamicReferenceType';
import { metadataFieldLabels } from '~/models/dynamicFields/handlers/processFlows/processFlowMetadataHandler';
import { ReferenceNodeType } from '~/enums/referenceNodeType';
import { ReferencePathNode } from '~/models/referencePaths/referencePathNode';
import { buildVarTag } from '~/helpers/froalaHelper';

export default function OnFlowErrorNotificationsContainable<TBase extends Constructor<TrackedModel>>(Base: TBase): typeof Base & Constructor<INotificationsContainer> {
  return class OnFlowErrorNotificationsContainer extends NotificationsContainable(Base)
    implements INotificationsContainer {

    createNotification(): Notification {
      const notification = super.createNotification();

      notification.loadFromJson({
        subject: this.notificationDefaultSubject(),
        body: this.notificationDefaultBody(),
      })

      return notification;
    }

    get notificationFactory(): typeof OnFlowErrorNotificationFactory {
      return OnFlowErrorNotificationFactory;
    }

    private notificationDefaultSubject(): string {
      return 'The process flow failed to complete';
    }

    private notificationDefaultBody(): string {
      const titleReferenceData: IDynamicReferencedThing = {
        id: Guid.create(),
        type: DynamicReferenceType.ProcessFlowMetadata,
        label: metadataFieldLabels[ReferenceNodeType.ProcessFlowTitle],
        path: [
          new ReferencePathNode(null, {
            reference_type: Number(ReferenceNodeType.ProcessFlowTitle),
            reference_id: String(ReferenceNodeType.ProcessFlowTitle),
          }).asJson(),
        ],
      };

      return `${ buildVarTag(titleReferenceData) } process flow has encountered an error. Please use the button below to view details about the error.`;
    }
  }
}